import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Agents from './pages/Agents';
import AgentDetail from './pages/AgentDetail';
// import Pricing from './pages/Pricing';
// import Resources from './pages/Resources';
// import CaseStudies from './pages/CaseStudies';
// import Login from './pages/Login';
import Signup from './pages/Signup';
import DeepSiteAgent from './pages/agents/DeepSiteAgent';
import Qwen25Agent from './pages/agents/qwen2.5';
import EasyControlGhibli from './pages/agents/EasyControl_Ghibli';
import FluxOne from './pages/agents/FLUX.1';
import SF3D from './pages/agents/SF3D';
import ScrollToTop from './components/ScrollToTop';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#8B5CF6',
    },
    secondary: {
      main: '#4ADE80',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'GT Walsheim Pro, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Navbar />
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/agents" element={<Agents />} />
              <Route path="/agent/:id" element={<AgentDetail />} />
              {/* <Route path="/pricing" element={<Pricing />} /> */}
              <Route path="/signup" element={<Signup />} />
              <Route path="/deepsite" element={<DeepSiteAgent />} />
              <Route path="/qwen2.5" element={<Qwen25Agent />} />
              <Route path="/easycontrol-ghibli" element={<EasyControlGhibli />} />
              <Route path="/flux-1" element={<FluxOne />} />
              <Route path="/sf3d" element={<SF3D />} />
              {/* <Route path="/resources" element={<Resources />} /> */}
              {/* <Route path="/case-studies" element={<CaseStudies />} /> */}
              {/* <Route path="/login" element={<Login />} /> */}
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App; 